import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'latestSales': {},
  'loadingSalesByDealer': false,
  'salesByDealer': [],
  'loadingSalesVsBudgets': false,
  'salesVsBudgets': [],
};

export const sales = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_SALES]: (state, action) => ({
      ...state,
      'latestSales': {},
      'loadingSalesByDealer': false,
      'salesByDealer': [],
      'loadingSalesVsBudgets': false,
      'salesVsBudgets': [],
    }),
    [ActionTypes.FETCHED_LATEST_SALES]: (state, action) => ({
      ...state,
      'latestSales': action.response.data,
    }),
    [ActionTypes.FETCHED_LATEST_SALES_FAILED]: (state, action) => ({
      ...state,
      'latestSales': {},
    }),
    [ActionTypes.FETCHING_SALES_AND_BUDGETS]: (state, action) => ({
      ...state,
      'loadingSalesVsBudgets': true,
    }),
    [ActionTypes.FETCHED_SALES_AND_BUDGETS]: (state, action) => ({
      ...state,
      'loadingSalesVsBudgets': false,
      'salesVsBudgets': action.response.data,
    }),
    [ActionTypes.FETCHED_SALES_AND_BUDGETS_FAILED]: (state, action) => ({
      ...state,
      'loadingSalesVsBudgets': false,
      'salesVsBudgets': [],
    }),
    [ActionTypes.FETCHING_SALES_BY_DEALER]: (state, action) => ({
      ...state,
      'loadingSalesByDealer': true,
    }),
    [ActionTypes.FETCHED_SALES_BY_DEALER]: (state, action) => ({
      ...state,
      'loadingSalesByDealer': false,
      'salesByDealer': action.response.data,
    }),
    [ActionTypes.FETCHED_SALES_BY_DEALER_FAILED]: (state, action) => ({
      ...state,
      'loadingSalesByDealer': false,
      'salesByDealer': [],
    }),
  })(state, action);
};
